<template>
  <div class="dashboard-gender-container">
    <div class="dashboard-gender-first-row">
      <div class="dashboard-gender-stats-container">
        <div class="dashboard-gender-percentage">
          {{ Math.round(chartData.pWomen || 0) }}%
        </div>
        <div class="dashboard-gender-stats">
          {{ nFormatter(chartData?.women, 0) }}
        </div>
      </div>
      <div class="dashboard-gender-icons-container">
        <img
          class="dashboard-gender-icon"
          src="../../../../../assets/icons/dashboard/woman.svg"
        >
        <img
          class="dashboard-gender-icon"
          src="../../../../../assets/icons/dashboard/men.svg"
        >
      </div>
      <div
        class="dashboard-gender-stats-container dashboard-gender-stats-right"
      >
        <div class="dashboard-gender-percentage">
          {{ Math.round(chartData?.pMen || 0) }}%
        </div>
        <div class="dashboard-gender-stats">
          {{ nFormatter(chartData.men, 0) }}
        </div>
      </div>
    </div>
    <div class="dashboard-gender-second-row">
      <span class="dashboard-gender-total-label"> {{ $t('label_dashboard_total') }}: </span>
      <span class="dashboard-gender-total">{{
          (chartData.total || 0).toLocaleString()
      }}</span>
    </div>
  </div>
</template>

<script>
import { ChartPie } from "@/utils/ChartPie";

export default {
  name: "DashboardGender",
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    nFormatter(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
      ];
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
          return num >= item.value;
        });
      return item
        ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
        : "0";
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-gender-container {
  width: 100%;
  padding: 0 20px;
}
.dashboard-gender-first-row {
  display: flex;
  gap: 25px;
  > * {
    flex-basis: calc(100% / 3);
  }
}
.dashboard-gender-second-row {
  text-align: center;
  padding-top: 5px;
}

.dashboard-gender-stats-container {
  color: #0c3a9b;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.dashboard-gender-percentage {
  font-size: 1rem;
  font-family: "Poppins-Regular";
}
.dashboard-gender-stats {
  font-size: 1.75rem;
  font-family: "Poppins-SemiBold";
}
.dashboard-gender-stats-right {
  text-align: right;
}

.dashboard-gender-total-label {
  color: #000000;
  font-family: "Poppins-Regular";
  font-size: 1rem;
}
.dashboard-gender-total {
  color: #1e4381;
  font-family: "Poppins-SemiBold";
  font-size: 1rem;
}

.dashboard-gender-icon {
  height: 100px;
  object-fit: contain;
}

.dashboard-gender-icons-container {
  display: flex;
  justify-content: center;
  gap: 15px;
}
</style>
